const ca = {
    nav: {
        servicios: "Serveis",
        sobre: "Sobre nosaltres",
        zona: "Zona de servei",
        faq: "FAQ",
        contacto: "Contacte",
        reserva: "Reserva el teu servei",
        openMenu: "Obrir el menú",
        closeMenu: "Tancar el menú",
    },
    hero: {
        eyebrow: "Serveis per a gossos · Maresme",
        l1: "El benestar",
        l2: "del teu gos,",
        l3: "a prop de casa.",
        sub: "Serveis per a gossos al Maresme, amb atenció personalitzada, confiança i molt amor pel que fem.",
        cta1: "Reserva el teu servei",
        cta2: "Coneix-nos",
        pills: ["Tracte personalitzat", "Fotos durant el servei", "D'Alella a Mataró"],
        cardTitle: "Maresme, Barcelona",
        cardSub: "Costa · Muntanya · Mediterrani",
        imgAlt: "En Mauro, el bulldog francès de la Irene, de passeig de tardor",
    },
    marquee: { b: "Proper · Professional · Mediterrani" },
    home: {
        servicesEyebrow: "Serveis",
        servicesTitle: "Tot el que el teu gos necessita",
        servicesSub: "Passejos, cura, allotjament i molt més, sempre amb atenció personalitzada i a la teva zona.",
        viewAll: "Veure tots els serveis →",
        faqEyebrow: "Preguntes freqüents",
        faqTitle: "Abans d'escriure'ns, potser això t'ajuda",
        faqViewAll: "Veure totes les preguntes →",
    },
    services: {
        "paseos": {
            nombre: "Passejos per a gossos",
            tagline: "Mar, muntanya i ritme caní.",
            desc: "Passejos pels camins, platges i senders del Maresme, adaptats a l'edat, l'energia i el caràcter del teu gos.",
            incluye: [
                "Passeig individual o en grup reduït",
                "Ruta adaptada a l'energia i edat del teu gos",
                "Aigua fresca i pauses a l'ombra",
                "Resum amb fotos en acabar cada passeig",
            ],
            paraQuien: "Per a gossos que necessiten gastar energia, socialitzar o simplement gaudir d'un bon passeig quan la teva jornada no ho permet.",
            duracion: "30, 60 o 90 min per passeig",
            chip: "des de 12 €",
            tarifas: [["Passeig 30 min", "12 €"], ["Passeig 60 min", "17 €"], ["Passeig 90 min", "24 €"]],
            faqs: [
                { q: "El meu gos passejarà sol o amb més gossos?", a: "Depèn del seu caràcter i del que acordem a la primera trobada. Prioritzem sempre la seva comoditat i seguretat." },
                { q: "Què passa si plou o fa molta calor?", a: "Adaptem horaris i rutes a la climatologia. A l'estiu evitem les hores centrals del dia." },
            ],
        },
        "dog-sitting": {
            nombre: "Dog sitting",
            tagline: "Companyia i cura per hores.",
            desc: "Acompanyament i cura del teu gos per hores: una tarda, una nit o aquell esdeveniment al qual no et pot acompanyar.",
            incluye: [
                "Companyia i supervisió constant durant les hores acordades",
                "Passeig, joc i alimentació seguint la seva rutina",
                "Actualitzacions amb fotos durant el servei",
                "Al teu domicili o al nostre",
            ],
            paraQuien: "Per a qui necessita cobrir hores concretes: un sopar, un esdeveniment, una jornada llarga o una escapada d'un dia.",
            duracion: "Per hores, segons necessitat",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "Hi ha un mínim d'hores?", a: "Treballem amb blocs flexibles. Explica'ns el teu cas i ho veiem junts." },
            ],
        },
        "cuidado-a-domicilio": {
            nombre: "Cura a domicili",
            tagline: "El teu gos, a casa seva, amb la seva rutina.",
            desc: "Ens desplacem a casa teva mentre ets fora, perquè el teu gos mantingui els seus costums en l'entorn que millor coneix.",
            incluye: [
                "Cura al teu domicili durant la teva absència",
                "Passejos, menjar, aigua i joc seguint la seva rutina",
                "Administració de medicació si cal",
                "Comunicació diària amb fotos i novetats",
            ],
            paraQuien: "Per a gossos que s'estressen fora de casa, seniors o llars on la rutina ho és tot.",
            duracion: "Des d'un dia fins a estades llargues",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "Us quedeu a dormir a casa o feu visites?", a: "Totes dues opcions són possibles segons el que el teu gos necessiti. Ho definim junts abans de reservar." },
            ],
        },
        "guarderia": {
            nombre: "Guarderia de dia",
            tagline: "El seu dia, ben aprofitat.",
            desc: "Cura diürna amb joc, descans i passejos, perquè el teu gos no passi el dia sol mentre treballes.",
            incluye: [
                "Jornada diürna de cura i companyia",
                "Passejos i temps de joc supervisat",
                "Moments de descans en un entorn tranquil",
                "Resum del dia amb fotos",
            ],
            paraQuien: "Per a gossos sociables que passen moltes hores sols entre setmana i necessiten activitat i companyia.",
            duracion: "Mitja jornada o jornada completa",
            chip: "des de 22 €/dia",
            tarifas: [["Guarderia de dia", "22 €/dia"], ["Guarderia premium", "28 €/dia"]],
            faqs: [
                { q: "Quants gossos hi ha alhora?", a: "Treballem amb grups molt reduïts per garantir atenció real a cada gos." },
                { q: "Què inclou la guarderia premium?", a: "Una jornada amb atenció extra: més passejos, joc individual i mimos addicionals. Consulta'ns els detalls." },
            ],
        },
        "alojamiento": {
            nombre: "Allotjament",
            tagline: "Una llar quan tu no hi ets.",
            desc: "El teu gos es queda en un entorn casolà, sense gàbies, amb l'atenció i l'afecte d'una casa de família.",
            incluye: [
                "Estada en ambient familiar, sense gàbies",
                "Passejos diaris inclosos",
                "Rutina de menjars i descans respectada",
                "Fotos i novetats cada dia",
            ],
            paraQuien: "Per a vacances, viatges de treball o qualsevol absència en què vulguis que el teu gos estigui com a casa.",
            duracion: "Per nits, caps de setmana o estades llargues",
            chip: "des de 29 €/nit",
            tarifas: [["Allotjament", "29 €/nit"], ["Allotjament premium", "35 €/nit"]],
            faqs: [
                { q: "Puc conèixer el lloc abans de reservar?", a: "Sí. Abans de qualsevol estada organitzem una trobada per conèixer-nos i resoldre dubtes." },
            ],
        },
        "visitas-a-domicilio": {
            nombre: "Visites a domicili",
            tagline: "Una visita just quan la necessita.",
            desc: "Visites puntuals a casa teva per donar-li de menjar, renovar-li l'aigua, un passeig curt o administrar-li medicació.",
            incluye: [
                "Menjar, aigua fresca i revisió de l'entorn",
                "Passeig curt o temps de joc",
                "Administració de medicació si la necessita",
                "Confirmació amb foto després de cada visita",
            ],
            paraQuien: "Per a cadells que encara no aguanten moltes hores, gossos seniors o dies puntuals complicats.",
            duracion: "Visites de 30 o 60 min",
            chip: "des de 16 €",
            tarifas: [["Visita 30 min", "16 €"], ["Visita 60 min", "22 €"]],
            faqs: [
                { q: "Quantes visites al dia podeu fer?", a: "Les que el teu gos necessiti. L'habitual és d'una a tres, segons el cas." },
            ],
        },
        "transporte": {
            nombre: "Transport per a mascotes",
            tagline: "L'hi portem, amb seguretat.",
            desc: "Trasllats en vehicle adaptat pel Maresme: veterinari, perruqueria o qualsevol cita a la qual no li puguis portar.",
            incluye: [
                "Vehicle condicionat per al transport de gossos",
                "Recollida i lliurament porta a porta",
                "Acompanyament durant la cita si ho necessites",
                "Confirmació d'arribada en temps real",
            ],
            paraQuien: "Per a qui no disposa de cotxe, no pot absentar-se de la feina o necessita un trasllat puntual.",
            duracion: "Trajectes puntuals o d'anada i tornada",
            chip: "des de 10 €",
            tarifas: [["Trajecte puntual (Dog Taxi)", "des de 10 €"]],
            faqs: [
                { q: "Cobriu trajectes fora del Maresme?", a: "El nostre focus és el Maresme, però explica'ns el trajecte i ho valorem." },
            ],
        },
        "personalizado": {
            nombre: "Serveis personalitzats",
            tagline: "Explica'ns què necessita el teu gos.",
            desc: "Cada gos és un món. Si el que necessites no encaixa en cap servei, ho parlem i dissenyem alguna cosa a mida.",
            incluye: [
                "Escoltem el teu cas sense compromís",
                "Proposta adaptada al teu gos i a la teva rutina",
                "Combinació de serveis si cal",
                "Pressupost clar abans de començar",
            ],
            paraQuien: "Per a necessitats especials, horaris complicats o situacions que requereixen una solució a mida.",
            duracion: "A definir segons el cas",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "Quin tipus de coses podeu valorar?", a: "Des d'acompanyament en mudances fins a rutines per a gossos amb necessitats especials. Escriu-nos i ho parlem." },
            ],
        },
    },
    detail: {
        inicio: "Inici",
        servicios: "Serveis",
        reservar: "Reservar",
        incluye: "Què inclou",
        paraQuien: "Per a qui és",
        duracion: "Durada",
        precio: "Preu",
        aConsultar: "A consultar",
        aConsultarText: "Explica'ns el teu cas i et donarem un pressupost clar i sense compromís, adaptat al servei i al teu gos.",
        notas: ["Festius: +20%", "Segon gos: +30–50%, segons el servei"],
        comoReservar: "Com reservar",
        pasos: [
            "Escriu-nos pel formulari o WhatsApp explicant-nos què necessites.",
            "Organitzem una primera trobada per conèixer el teu gos, sense compromís.",
            "Confirmem el servei i el pressupost, i comencem quan vulguis.",
        ],
        primerTitle: "Primera trobada sense compromís",
        primerText: "Abans de qualsevol servei, ens coneixem en persona. El teu gos mana.",
        faqTitle: "Preguntes sobre",
        hablamos: "En parlem de",
        hablamosText: "Explica'ns com és el teu gos i què necessites. Et respondrem amb una proposta clara i sense compromís.",
        enMaresme: "al Maresme",
    },
    trust: {
        eyebrow: "Per què triar-nos",
        title: "Confiança que es demostra, no que es promet",
        sub: "Sabem què significa deixar el teu gos en mans d'una altra persona. Per això treballem així.",
        items: [
            { title: "Atenció personalitzada", desc: "Pocs gossos alhora i un tracte pensat per a cada caràcter. Res de cadenes de muntatge." },
            { title: "Comunicació durant el servei", desc: "Fotos i novetats mentre cuidem del teu gos, perquè tu també estiguis tranquil." },
            { title: "Experiència amb gossos", desc: "Tractem cada gos amb la calma i el respecte que ens agradaria per al nostre." },
            { title: "Coneixement del Maresme", desc: "Hi vivim: coneixem els senders, les ombres d'estiu i els racons tranquils." },
            { title: "Protocols clars", desc: "Primera trobada prèvia, informació detallada del teu gos i acords per escrit." },
            { title: "Transparència en preus", desc: "Tarifes clares i pressupost abans de començar, sense sorpreses ni lletra petita." },
        ],
    },
    areaHome: {
        eyebrow: "Zona de servei",
        title: "Del Maresme, per al Maresme",
        sub: "No som una empresa més de Barcelona: hi vivim i hi treballem. Passegem pels seus senders, coneixem les seves platges i cuidem gossos d'Alella a Mataró.",
        p: "Si busques un passejador de gossos, un cuidador o un dog sitter al Maresme que conegui de debò la zona, ets al lloc adequat.",
        cta: "Veure tots els municipis",
    },
    map: { sea: "Mar Mediterrània", mountains: "Serralada Litoral", around: "i rodalies" },
    steps: {
        eyebrow: "Com funciona",
        title: "Quatre passos i molta tranquil·litat",
        items: [
            { num: "01", title: "Contacta amb nosaltres", desc: "Omple el formulari o escriu-nos per WhatsApp explicant-nos què necessita el teu gos." },
            { num: "02", title: "Coneixem el teu gos", desc: "Primera trobada sense compromís per conèixer-nos, resoldre dubtes i entendre el seu caràcter i rutines." },
            { num: "03", title: "Triem el servei adequat", desc: "Et proposem el servei i el pla que millor encaixa, amb un pressupost clar." },
            { num: "04", title: "El teu gos gaudeix, tu descanses", desc: "Ens ocupem de tot i et mantenim al dia amb fotos i novetats." },
        ],
    },
    testi: {
        eyebrow: "Testimonis",
        title: "El que diuen els nostres gossos (bé, les seves famílies)",
        sub: "Les primeres famílies que confien en nosaltres ho expliquen millor que nosaltres.",
        items: [
            { text: "Deixar en Yugus amb la Irene va ser la millor decisió. Després de cada passeig ens arribaven fotos i un resum que ens feia sentir que hi érem. Es nota que estima els gossos de veritat.", author: "Laura", dog: "amb en Yugus" },
            { text: "La Tina és gran i molt de la seva rutina, i la Irene ho va entendre des del primer encontre. Tornar a casa i trobar-la tranquil·la i feliç no té preu.", author: "Alba", dog: "amb la Tina" },
        ],
        pending: "El proper testimoni pot ser el del teu gos",
    },
    faqs: [
        { q: "Com reservo un servei?", a: "Omple el formulari de contacte o escriu-nos per WhatsApp. Et respondrem per conèixer el teu gos i concretar el servei, sense cap compromís." },
        { q: "Quant costen els serveis?", a: "Passejos des de 12 € (30 min), visites a domicili des de 16 €, guarderia 22 €/dia, allotjament 29 €/nit i Dog Taxi des de 10 €. Festius +20% i segon gos +30–50% segons el servei. Sempre et confirmem el preu exacte abans de reservar." },
        { q: "Puc cancel·lar o modificar una reserva?", a: "Política de cancel·lació en definició. La publicarem aquí tan bon punt estigui confirmada. (editable)" },
        { q: "Què passa durant la primera trobada?", a: "Ens coneixem en persona, el teu gos es familiaritza amb nosaltres i recopilem tota la informació necessària: rutines, caràcter, salut i manies. És gratuïta i sense compromís." },
        { q: "Quina informació necessiteu sobre el meu gos?", a: "Edat, raça, caràcter, rutines de menjar i passeig, salut, medicació si en pren, sociabilitat amb altres gossos i qualsevol detall que et sembli important." },
        { q: "En quines zones treballeu?", a: "A tot el Maresme: Alella, el Masnou, Premià de Mar, Premià de Dalt, Vilassar de Mar, Vilassar de Dalt, Cabrils, Argentona, Mataró i rodalies. Si ets a prop, consulta'ns." },
        { q: "Teniu disponibilitat caps de setmana i festius?", a: "Sí, també treballem caps de setmana i festius (amb un suplement del 20% els festius). Consulta'ns les dates que necessites." },
        { q: "Oferiu serveis personalitzats?", a: "Sí. Si el teu gos té necessitats especials o el teu cas no encaixa en un servei estàndard, explica'ns-ho i dissenyem una solució a mida." },
        { q: "Què passa si hi ha una emergència?", a: "A la primera trobada recopilem les dades del teu veterinari de referència i un contacte d'emergència, per saber exactament com actuar si calgués." },
        { q: "Ateneu gossos amb necessitats especials?", a: "Sí, valem cada cas de forma individual a la primera trobada per assegurar-nos de poder oferir la cura adequada." },
    ],
    contact: {
        whatsappMsg: "Hola, m'agradaria rebre informació sobre els serveis de Maresme Dog Care.",
        eyebrow: "Reserves i contacte",
        title: "Explica'ns què necessita el teu gos",
        sub: "Omple el formulari i et respondrem molt aviat per conèixer-nos, resoldre dubtes i preparar un pressupost sense compromís.",
        note: "També ens pots escriure directament per WhatsApp si ho prefereixes. Sense compromís i amb tota la calma del món.",
        form: {
            nombre: "El teu nom *", nombrePh: "Maria Garcia",
            email: "Correu electrònic *", emailPh: "maria@email.com",
            telefono: "Telèfon", telefonoPh: "600 123 456",
            municipio: "Municipi *", municipioPh: "Tria el teu municipi", otro: "Un altre / proper",
            perro: "Nom del teu gos *", perroPh: "Mauro",
            edad: "Edat del teu gos", edadPh: "3 anys",
            servicio: "Servei que necessites *", servicioPh: "Tria un servei", servicioOtro: "Un altre / no ho tinc clar",
            fechas: "Dates aproximades", fechasPh: "Del 12 al 18 d'agost",
            mensaje: "Missatge", mensajePh: "Explica'ns com és el teu gos, la seva rutina i què necessites…",
            submit: "Explica'ns què necessita el teu gos",
            sending: "Enviant…",
            privacy: "Sense compromís. Només farem servir les teves dades per respondre't.",
            toastOk: "Sol·licitud enviada. Gràcies!",
            toastErr: "No s'ha pogut enviar. Torna-ho a provar o escriu-nos per WhatsApp.",
        },
        success: {
            title: "Hem rebut el teu missatge",
            text1: "Gràcies per escriure'ns. Et contactarem molt aviat per conèixer",
            text2: "i veure què necessita.",
            reset: "Enviar una altra sol·licitud",
        },
    },
    contactPage: {
        whatsapp: "WhatsApp", email: "Correu", instagram: "Instagram",
        zona: "Zona", zonaValue: "Tot el Maresme, Barcelona",
    },
    footer: {
        tagline: "Serveis per a gossos al Maresme. Propers, professionals i amb molt amor pel que fem.",
        servicios: "Serveis", nosotros: "Nosaltres", legal: "Legal",
        verTodos: "Veure tots →",
        sobre: "Sobre nosaltres", zona: "Zona de servei", faq: "Preguntes freqüents", contacto: "Contacte i reserves",
        aviso: "Avís legal", privacidad: "Política de privacitat", cookies: "Cookies",
        claim: "El benestar del teu gos, a prop de casa.",
    },
    servicesPage: {
        eyebrow: "Serveis per a gossos al Maresme",
        title: "Serveis pensats per a cada gos",
        sub: "Del passeig diari a l'allotjament durant les teves vacances. Tots els nostres serveis comencen igual: coneixent el teu gos.",
        ctaEyebrow: "Comencem?",
        ctaTitle: "Explica'ns què necessites",
        ctaSub: "Sense compromís. Et respondrem per conèixer el teu gos i preparar un pressupost clar.",
    },
    about: {
        eyebrow: "Sobre nosaltres",
        title: "Hola, soc la Irene",
        p1a: "Em dic",
        p1b: "i he compartit la meva vida amb gossos des de sempre. També col·laboro com a voluntària en protectores i organitzo esdeveniments i activitats relacionades amb el món caní.",
        p2: "D'aquesta passió neix Maresme Dog Care: la voluntat de crear en aquesta comarca uns serveis pensats des de l'afecte, l'experiència i el respecte per cada gos, entenent que cada un té la seva pròpia personalitat, necessitats i forma de gaudir.",
        p3: "Visc al Maresme i el gaudeixo cada dia: els seus camins entre vinyes, les seves platges de matinada, la serralada quan apreta la calor. I gairebé sempre amb en Mauro, el meu bulldog francès i company d'aventures.",
        caption: "La Irene i en Mauro, companys d'aventures",
        galleryEyebrow: "La vida amb gossos",
        galleryTitle: "Així es veu un dia qualsevol",
        gallery: ["Estiu al Mediterrani, amb en Mauro", "Tardor entre castanyers", "Ni la neu ens para", "En Mauro, sempre explorant"],
        blocks: [
            { title: "La nostra filosofia", text: "Pocs gossos, molta atenció. Preferim dir que no abans que oferir una cura que no sigui excel·lent. Cada gos és únic i mereix un pla a la seva mida." },
            { title: "Compromís amb el benestar", text: "El benestar del teu gos guia cada decisió: rutines respectades, rutes adaptades, descans quan el necessita i comunicació constant amb tu." },
            { title: "Experiència de la vida real", text: "La nostra no ve d'un fulletó: ve d'anys compartits amb gossos, del voluntariat en protectores i d'organitzar activitats del món caní. Gossos de tot tipus, caràcter i energia." },
        ],
        ctaLine: "Ens coneixem? El primer cafè (i la primera olorada) convidem nosaltres.",
        cta: "Explica'ns què necessita el teu gos",
    },
    areaPage: {
        eyebrow: "Zona de servei",
        title: "Serveis per a gossos al Maresme",
        sub: "Cobrim tota la comarca del Maresme, de la costa a la serralada. Si hi vius (o hi tens la segona residència), cuidem del teu gos a prop de casa.",
        h2: "Passejadors i cuidadors de gossos que coneixen el territori",
        p1: "El Maresme no és només la nostra zona de treball: és casa nostra. Coneixem els senders de la Serralada Litoral per als gossos amb més energia, les hores bones per baixar a la platja a l'estiu i els racons tranquils per als que prefereixen calma.",
        p2a: "Si busques un",
        p2b: "passejador de gossos al Maresme",
        p2c: "un",
        p2d: "dog sitter de confiança",
        p2e: "o",
        p2f: "cura de gossos a domicili",
        p2g: "aquí som: a prop, disponibles i amb un tracte que comença sempre per conèixer el teu gos.",
        municipiosTitle: "Municipis on treballem",
        line1: "Cura de gossos a",
        other: "Vius en un altre municipi proper? Escriu-nos: si hi podem arribar bé, hi arribem.",
        ctaTitle: "El teu gos, en bones mans i a prop de casa",
        ctaSub: "Explica'ns en quin municipi ets i què necessita el teu gos. Et respondrem amb una proposta sense compromís.",
        cta: "Reserva el teu servei",
    },
    faqPage: {
        eyebrow: "Preguntes freqüents",
        title: "Dubtes resolts, sense embuts",
        sub: "Reserves, preus, cancel·lacions, primeres trobades i tot el que acostumes a preguntar-te abans de confiar-nos el teu gos.",
        noAnswer: "No hi trobes la teva resposta?",
        cta: "Escriu-nos directament",
    },
    cookie: {
        text: "Fem servir galetes tècniques i d'anàlisi per millorar la teva experiència. Pots acceptar-les o rebutjar-les quan vulguis.",
        accept: "Acceptar",
        reject: "Rebutjar",
        more: "Més informació",
    },
    welcome: {
        title: "Quina alegria tornar-te a veure!",
        text: "Seguim aquí, d'Alella a Mataró, per al que necessiti el teu gos.",
        close: "Tancar",
    },
    legal: {
        updated: "Darrera actualització: setembre de 2026",
        aviso: {
            title: "Avís legal",
            sections: [
                { h: "1. Titular del lloc web", p: "En compliment de la Llei 34/2002, de Serveis de la Societat de la Informació i de Comerç Electrònic (LSSI-CE), s'informa que aquest lloc web és titularitat d'Irene Infante Riol, amb NIF 39403930P, domicili a Carrer Romaní 19, 08348 Cabrils (Barcelona) i correu electrònic de contacte ireneinfanteriol@gmail.com." },
                { h: "2. Objecte", p: "Aquest lloc web té per objecte informar sobre els serveis de cura i benestar per a gossos que Maresme Dog Care ofereix a la comarca del Maresme (Barcelona), així com facilitar un canal de contacte per sol·licitar informació o pressupostos." },
                { h: "3. Condicions d'ús", p: "L'accés i ús d'aquest lloc web atribueix la condició d'usuari i implica l'acceptació d'aquest avís legal. L'usuari es compromet a fer un ús lícit, diligent i respectuós dels continguts. La titular no es responsabilitza del mal ús que se'n faci ni dels danys que se'n derivin." },
                { h: "4. Propietat intel·lectual", p: "Tots els continguts d'aquest lloc web (textos, fotografies, disseny, logotip i codi) són titularitat d'Irene Infante Riol o s'utilitzen amb llicència, i estan protegits per la normativa de propietat intel·lectual. Se'n prohibeix la reproducció, distribució o comunicació pública sense autorització expressa." },
                { h: "5. Responsabilitat i enllaços", p: "La titular no es fa responsable dels continguts de llocs web de tercers enllaçats des d'aquesta pàgina, ni garanteix l'absència d'errors o la disponibilitat contínua del lloc, tot i que treballarà per evitar-los i esmenar-los." },
                { h: "6. Legislació aplicable", p: "Aquest avís legal es regeix per la legislació espanyola. Per a qualsevol controvèrsia, les parts se sotmeten als jutjats i tribunals del domicili de l'usuari, llevat que la normativa aplicable disposi una altra cosa." },
            ],
        },
        privacidad: {
            title: "Política de privacitat",
            sections: [
                { h: "1. Responsable del tractament", p: "La responsable del tractament de les teves dades personals és Irene Infante Riol, amb NIF 39403930P, domicili a Carrer Romaní 19, 08348 Cabrils (Barcelona) i correu electrònic ireneinfanteriol@gmail.com." },
                { h: "2. Dades que recollim i finalitat", p: "A través del formulari de contacte recollim el teu nom, correu electrònic, telèfon, municipi i la informació que ens facilites sobre el teu gos i el servei que necessites. Aquestes dades s'utilitzen únicament per respondre a la teva sol·licitud, contactar amb tu i preparar un pressupost o proposta de servei." },
                { h: "3. Base jurídica", p: "La base legal per al tractament és el teu consentiment, atorgat en enviar el formulari, i l'aplicació de mesures precontractuals sol·licitades per tu en demanar-nos informació o pressupost (art. 6.1.a i 6.1.b del RGPD)." },
                { h: "4. Conservació i destinataris", p: "Les dades es conserven durant el temps necessari per atendre la teva sol·licitud i, si escau, la relació de servei. No se cedeixen a tercers ni s'utilitzen amb finalitats publicitàries. L'enviament de notificacions per correu electrònic es fa a través d'un proveïdor tècnic que actua com a encarregat del tractament." },
                { h: "5. Els teus drets", p: "Pots exercir en qualsevol moment els teus drets d'accés, rectificació, supressió, oposició, limitació i portabilitat escrivint a ireneinfanteriol@gmail.com. Si consideres que el tractament no s'ajusta a la normativa, pots presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (www.aepd.es)." },
                { h: "6. Seguretat", p: "Apliquem mesures tècniques i organitzatives apropiades per protegir les teves dades personals davant d'accessos no autoritzats, pèrdua o alteració." },
            ],
        },
        cookies: {
            title: "Política de cookies",
            sections: [
                { h: "1. Què són les galetes", p: "Les galetes són petits fitxers que s'emmagatzemen al teu dispositiu en visitar un lloc web i que permeten, entre d'altres coses, recordar les teves preferències o analitzar com s'utilitza la pàgina." },
                { h: "2. Galetes que utilitza aquest lloc", p: "Aquest lloc web utilitza galetes tècniques necessàries per al seu correcte funcionament i galetes d'anàlisi que ens ajuden a entendre com s'usa la pàgina i millorar-la. En entrar veuràs un avís on pots acceptar-les o rebutjar-les; si les rebutges, l'analítica queda desactivada. No utilitzem galetes publicitàries." },
                { h: "3. Com gestionar les galetes", p: "A més de l'avís d'aquest web, pots permetre, blocar o eliminar les galetes des de la configuració del teu navegador. Tingues en compte que blocar les galetes tècniques pot afectar el funcionament de la web. Consulta l'ajuda del teu navegador (Chrome, Safari, Firefox, Edge) per a més detalls." },
                { h: "4. Actualitzacions", p: "Aquesta política es pot actualitzar per reflectir canvis en les galetes utilitzades. Per a qualsevol dubte, escriu-nos a ireneinfanteriol@gmail.com." },
            ],
        },
    },
};

export default ca;
